// Mock data for FLIX — an original payments app brand (frontend-only demo).
export const images = {
  hero: 'https://images.pexels.com/photos/3932728/pexels-photo-3932728.jpeg',
  cafe: 'https://images.pexels.com/photos/6205512/pexels-photo-6205512.jpeg',
  florist2: 'https://images.pexels.com/photos/5410100/pexels-photo-5410100.jpeg',
  contactless: 'https://images.pexels.com/photos/7561698/pexels-photo-7561698.jpeg',
  freelancer: 'https://images.unsplash.com/photo-1612299273045-362a39972259',
  vendor: 'https://images.unsplash.com/photo-1768162126072-50b7d7c66064',
  paySuccess: 'https://images.pexels.com/photos/6406691/pexels-photo-6406691.jpeg',
};

export const navLinks = [
  { label: 'Tap to Pay', to: '/tap-to-pay' },
  { label: 'Payment Links', to: '/payment-links' },
  { label: 'Storefront', to: '/storefront' },
  { label: 'FLIX AI', to: '/flix-ai' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'Blog', to: '/blog' },
];

export const paymentMethods = ['Visa', 'Mastercard', 'Amex', 'Apple Pay', 'Google Pay', 'Discover', 'JCB', 'Samsung Pay'];

export const stats = [
  { value: '0$', label: 'Monthly fees' },
  { value: '1.4%', label: 'Per tap' },
  { value: '2s', label: 'To get paid' },
  { value: '50', label: 'States covered' },
];

export const featureCards = [
  { icon: 'Smartphone', title: 'Tap to Pay on your phone', text: 'Your phone is the reader. Let customers pay with a card or wallet — no extra hardware needed.' },
  { icon: 'Link2', title: 'Payment links in one tap', text: 'Selling remotely? Share a link by text, DM or email and get paid from anywhere.' },
  { icon: 'Zap', title: 'Money that lands instantly', text: 'Every sale settles to your FLIX balance in seconds. No waiting days for a payout.' },
  { icon: 'BadgePercent', title: 'Pricing that stays simple', text: 'Flat, honest rates. No setup costs, no monthly bill, no surprises on your statement.' },
];

export const steps = [
  { num: '01', title: 'Enter the amount', text: 'Open FLIX, punch in the price and add a tip option if you like.', img: images.hero },
  { num: '02', title: 'Ask for a tap', text: 'Your customer taps their card, phone or watch right on your screen.', img: images.contactless },
  { num: '03', title: 'You\u2019re paid', text: 'Funds hit your FLIX balance instantly — spend or transfer whenever.', img: images.paySuccess },
];

export const aiCards = [
  { icon: 'LineChart', title: 'Know your numbers', text: 'Live sales breakdowns, cashflow trends and alerts before a problem costs you money.' },
  { icon: 'MapPin', title: 'Find your next sale', text: 'FLIX scans your area for markets, fairs and pop-ups that match what you sell.' },
  { icon: 'Sparkles', title: 'A team in your pocket', text: 'Marketing copy, a growth plan and a business analyst — all working while you sell.' },
];

export const testimonials = [
  { text: 'Set up in five minutes and took my first payment the same afternoon. Ridiculously easy.', name: 'Mara Devlin', role: 'Ceramics maker' },
  { text: 'The instant payout is the real deal. Money is in my balance before the customer leaves.', name: 'Theo Park', role: 'Coffee cart owner' },
  { text: 'I sell at three markets a week and FLIX handles every card without a single hiccup.', name: 'Priya Nair', role: 'Street food vendor' },
  { text: 'Payment links changed my side hustle. I send one text and I get paid, simple as that.', name: 'Dominic Rhodes', role: 'Freelance designer' },
  { text: 'No monthly fee means I actually keep my margins. That matters when you are just starting.', name: 'Alina Costa', role: 'Florist' },
  { text: 'The little sales insights nudge me to restock the right things. Feels like a co-pilot.', name: 'Jonah West', role: 'Vintage reseller' },
];

export const faqs = [
  { q: 'How fast do I actually get paid?', a: 'Instantly. The moment a sale completes, the funds land in your FLIX balance — no 1–2 business day wait.' },
  { q: 'Do I need any extra hardware?', a: 'No. If your phone supports contactless (NFC), it is your card reader. Just download FLIX and turn it on.' },
  { q: 'What can customers pay with?', a: 'Any contactless credit or debit card, plus Apple Pay, Google Pay, Samsung Pay and other digital wallets.' },
  { q: 'What are the fees?', a: 'A flat 1.4% per in-person tap and 3.9% + $0.30 per payment link. No setup fee and no monthly charge.' },
  { q: 'How do I spend my money?', a: 'Use the free FLIX card instantly online or in-store, or transfer to your bank with same-day settlement.' },
  { q: 'Is FLIX secure?', a: 'Yes. Card numbers and PINs are never stored on your device or our servers. Every payment is encrypted end to end.' },
];
